export const EDITOR_ACCENT = "#0b3d87";

export const LAYOUT_HEADER_BG = {
  default: "#f8fafc",
  hovered: "#f1f5f9",
  selected: "#dbeafe",
};

export const CELL_LABEL_OPACITY = {
  hidden: 0,
  hovered: 0.92,
  selected: 1,
};

/** Editor-only outline so layout blocks are visible in the canvas (not exported to HTML). */
export const LAYOUT_CANVAS_BORDER = "1px solid #cbd5e1";

/** Editor-only guide around each cell chrome wrapper (not exported to HTML). */
export const CELL_EDITOR_GUIDE_BORDER = "1px dashed #cbd5e1";

export const CELL_DROP_OK_OUTLINE = "2px solid #16a34a";
export const CELL_DROP_INVALID_OUTLINE = "2px solid #dc2626";

/** Minimum row height in the structure canvas (px). */
export const ROW_CONTENT_MIN_HEIGHT_PX = 72;
 